/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// import { Logger } from "cms/utils/log/logger";
// import { createSlice } from '@reduxjs/toolkit';

// action - state management
import { REGISTER, LOGIN, LOGOUT } from "./auth.actions";
import { authState } from "./auth.state";

const authReducer = (state = authState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user, token } = action.payload;
            return {
                ...state,
                user,
                token,
            };
        }
        case LOGIN: {
            const { user, token, organization } = action.payload;
            // Logger.debug(`Login Reducer:`, action.payload)
            // Logger.debug(`Login Reducer user:`, user)
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user,
                token,
                organization,
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                token: null,
                organization: null,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export { authReducer };
